import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import { getUserInfo, getRouters } from '@/request/api/user'
import store from '@/store/index.js'
import { filterAuthRouter, setAsyncRouters, filterAsyncRouter } from "@/utils/routeUtil.js";
import { computed } from "vue";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false }) // 不显示加载中页面右上角的旋转图标

const baseRoutes = [
  {
    path: '/',
    name: 'Layout',
    component: () => import('../views/Layout.vue'),
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'Index',
        meta: {
          title: '首页',
          icon: 'home',
        },
        component: () => import('../views/Index.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login/Login.vue')
  },
]

const staticRouter2 = [
  /* {
    path: '/operator',
    name: 'operator',
    component: 'Layout',
    meta: {
      title: '客户管理',
      icon: 'kehu',
    },
    children: [
      {
        path: '/operator/index',
        name: 'operator/index',
        component: 'operator/index/index',
        meta: {
          title: '客户设置',
          icon: 'shezhi',
        },
        children: null
      },
      {
        path: '/operator/admin',
        name: 'operator/admin',
        component: 'operator/admin/index',
        meta: {
          title: '管理员设置',
          icon: 'guanliyuan',
        },
        children: null
      },
    ]
  },
  {
    path: '/fee',
    name: 'fee',
    component: 'Layout',
    meta: {
      title: '计费设置',
      icon: 'jifeiguanli',
    },
    children: [
      {
        path: '/fee/plan',
        name: 'fee/plan',
        component: 'fee/plan/index',
        meta: {
          title: '计费方案设置',
          icon: 'jifeiguanli',
        },
        children: null
      }
    ]
  },
  {
    path: '/source-material',
    name: 'source-material',
    component: 'Layout',
    meta: {
      title: '素材管理',
      icon: 'sucai',
    },
    children: [
      {
        path: '/source-material/gallery',
        name: 'source-material/gallery',
        component: 'source-material/gallery/index',
        meta: {
          title: '图库管理',
          icon: 'picture',
        },
        children: null
      },
      {
        path: '/source-material/cate',
        name: 'source-material/cate',
        component: 'source-material/cate/index',
        meta: {
          title: '分类管理',
          icon: 'fenlei',
        },
        children: null
      }
    ]
  },
  {
    path: '/hotel',
    name: 'hotel',
    component: 'Layout',
    meta: {
      title: '酒店管理',
      icon: 'jiudian',
    },
    children: [
      {
        path: '/hotel/index',
        name: 'hotel/index',
        component: 'hotel/index/index',
        meta: {
          title: '酒店设置',
          icon: 'jiudianshezhi',
        },
        children: null
      },
      {
        path: '/hotel/admin',
        name: 'hotel/admin',
        component: 'hotel/admin/index',
        meta: {
          title: '管理员设置',
          icon: 'guanliyuan',
        },
        children: null
      }
    ]
  },
  {
  path: '/room/index',
  name: 'room/index',
  component: 'room/index/index',
  meta: {
    title: '房间管理',
    icon: 'fangjianguanli',
  },
  children: null
}
  {
    path: '/client-side',
    name: 'client-side',
    component: 'Layout',
    meta: {
      title: '客户端管理',
      icon: 'dianshiji',
    },
    children: [
      {
        path: '/authorize/index',
        name: 'authorize/index',
        component: 'authorize/index/index',
        meta: {
          title: '计费方案设置',
          icon: 'shezhi',
        },
        children: null
      },
      {
        path: '/client-side/display',
        name: 'client-side/display',
        component: 'client-side/display/index',
        meta: {
          title: '展示图配置',
          icon: 'picture',
        },
        children: null
      },
      {
        path: '/client-side/feeplan',
        name: 'client-side/feeplan',
        component: 'client-side/feeplan/index',
        meta: {
          title: '计费方案列表',
          icon: 'dingdan',
        },
        children: null
      },
      {
        path: '/order/index',
        name: 'order/index',
        component: 'order/index/index',
        meta: {
          title: '订单列表',
          icon: 'dingdan',
        },
        children: null
      },
      {
        path: '/client-side/data',
        name: 'client-side/data',
        component: 'client-side/data/index',
        meta: {
          title: '数据统计',
          icon: 'shuju',
        },
        children: null
      },
    ]
  },
  {
    path: '/room',
    name: 'room',
    component: 'Layout',
    meta: {
      title: '房间管理',
      icon: 'fangjianguanli',
    },
    children: [
      {
        path: '/room/index',
        name: 'room/index',
        component: 'room/index/index',
        meta: {
          title: '房间列表',
          icon: 'fangjianguanli',
        },
        children: null
      }
    ]
  } */
]
export const staticRouter = [
  {
    path: '/system',
    name: 'system',
    component: 'Layout',
    meta: {
      title: '系统管理',
      icon: 'picture',
    },
    children: [
      {
        path: '/system/menu',
        name: 'system/menu',
        component: 'system/menu/index',
        meta: {
          title: '菜单管理',
          icon: 'picture',
        },
        children: null
      }

    ]
  }
]


const router = createRouter({
  //history: createWebHistory(),
  history: createWebHashHistory(),
  routes: baseRoutes
})


router.beforeEach(async (to, from, next) => {
  NProgress.start()
  if (to.path === '/login') {
    // 跳转登录页，直接放行
    next()
  } else {
    let token = localStorage.getItem('token')
    if (!token) {
      // 是否存在token，没有则直接重定向登录页
      //console.log('没有token，直接重定向到登录页');
      next(`/login`);
      return
    }
    // 判断路由是否加载过
    let isRoutesLoaded = computed(() => store.state.user.isRoutesLoaded).value
    if (isRoutesLoaded) {
      // 如果有则放行
      //console.log('路由跳转，已经加载过动态路由了，直接放行');
      next()
      return
    }
    // 读取asyncRouter是否存在，不存在则通过接口获取最新的
    let asyncRouters = JSON.parse(sessionStorage.getItem('asyncRouters'))
    if (!asyncRouters) {
      const { data: res } = await getRouters()
      asyncRouters = res.data ?? []

      // 临时测试用
      /* staticRouter.forEach(item => {
        asyncRouters.push(item)
      }); */
    }
    // 添加设置动态路由
    //console.log('添加设置动态路由', asyncRouters);

    setAsyncRouters(asyncRouters)

    //console.log('当前页面的路由：', router.getRoutes());
    store.commit('setRoutesLoaded', true)
    //添加完路由后跳转
    next({ ...to, replace: true })
  }
})

router.afterEach(() => {
  NProgress.done()
})


/* 
  登录状态
  用户信息
  路由
 
 若依实现原理


 1.判断token
 2.判断是否去登录页
 3.判断是否有用户信息
 4.判断是否有请求的路由数组



去index页
进入判断
  如果没有登录，登录状态为下线，直接跳转登录页
    如果有登录，没有用户信息,直接跳转登录页

    有用户信息，放行下一步判断

    判断路由是否添加过
      没有则重新获取路由进行添加
        有则直接放行

*/

// 首选说一下这里的场景，这里应用场景比较少，只有登录页是可以直接访问的，其余都通过路由来获取
// 首先token肯定是登录时调用接口获取到的信息，然后我把信息放在了vuex中，同时本地缓存也存储了一份
// 这里不对token过期处理是因为，如果在正常使用中token过期了，首先调用接口会报401，那我对401状态码已经做了全局处理跳转登录页了
// 而如果是刷新时过期了，我也有个方法，main.js做了vuex持久化 防止刷新时vuex丢失数据，这里可以拿到过期时间和当前的时间做比对，如果过期了，也就把vuex中的相应的数据和本地缓存的数据清除了

export default router
